import React, {Component} from "react"
import {debounce} from "lodash"

import {formatCurrency} from "@irati/utils/currency/formatCurrency"

import {Input} from "./"

interface Props {
  currency: string
  id: string
  label: string
  min: string
  name: string
  onChange(value: string): void
  step: string
  value: string
  validation?: any
}

class PriceInput extends Component<Props> {
  constructor(props: Props) {
    super(props)
    this.onChange = debounce(this.onChange, 200)
  }

  onChange = (value: string) => {
    if (value && Number(value) > 0) {
      this.props.onChange(value)
    }
  }

  onBlur = (value: string) => {
    const price = Number.parseFloat(value).toFixed(2)
    if (price && Number(price) > 0) {
      this.props.onChange(price)
    }
  }

  render() {
    const {currency, id, label, min, name, step, value, validation} = this.props

    return (
      <Input
        addon={{before: formatCurrency({currencyCode: currency})}}
        id={id}
        label={label}
        min={min}
        name={name}
        onBlur={this.onBlur}
        onChange={this.onChange}
        step={step}
        type="number"
        value={value}
        validation={validation}
      />
    )
  }
}

export default PriceInput
